import React, { useEffect, useRef, useState } from "react";
import Input from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FormControl, FormHelperText } from "@mui/material";
import { styles } from './TellInputField.style';

const CustomPhoneInput = React.forwardRef(({
    label, // Input Label, aria-label
    value, // Value of the input
    onChange, // Callback function to handle input change
    onBlur, // Callback function to handle input blur
    name, // Input name, id(if not provided)
    error, // Is there Error? (true/ false)
    helperText, // Helper Text
    ...props
  }, ref ) => {
    const inputId = `phone-input-${name}`; // Create an id for the input
    const inputRef = useRef(null); // Create a ref for the input
    const disabled = props.disabled
    
    const [isFocused, setIsFocused] = useState(false); // State to track focus

    // handle on change method
    const handleOnChange = (phone) => {
      const sanitizedPhone = phone.replace(/\+/g, '').replace(/[^0-9]/g, ''); // input field sanitized for autofill
      onChange({
        target: {
          name: name,
          value: sanitizedPhone,
        },
      });
    }

    // handle on blur
    const handleOnBlur = (e) => {
      onBlur && onBlur(e);
      setIsFocused(false); // Set focus to false on blur
    }

    // handle on focus
    const handleOnFocus = () => {
      setIsFocused(true) // Set focus to true on focus
    }

    // Detect value change after autofill (watch the value prop)
    useEffect(() => {
      if (value) {
        const sanitizedPhone = value.replace(/\+/g, '').replace(/[^0-9]/g, ''); // input field sanitized for autofill
        if (sanitizedPhone !== value) {
          // Trigger onChange if autofill or value change occurs
          onChange({
            target: {
              name: name,
              value: sanitizedPhone,
            },
          });
        }
      }
    }, [value, onChange, name]);

    // Input Props
    const inputProps={
        ref: inputRef,
        placeholder: props.placeholder || props.label,
        id: inputId,
        name: name,
        onBlur: handleOnBlur,
        onFocus: handleOnFocus,
        style: styles.inputStyle(disabled, error, isFocused),
    }

    // Handle focus when the component mounts or when autoFocus prop changes
    useEffect(() => {
      if (props.autoFocus && inputRef.current) {
        inputRef.current.focus();
      }
    }, [props.autoFocus]);

    useEffect(() => {
      const makeFlagDropDownNotSelectable = () => {
        const flagDropDownElement = document.querySelectorAll('.selected-flag');

        if(flagDropDownElement?.length > 0) {         
          flagDropDownElement.forEach(element => {
            if(element)
              element.setAttribute('tabindex', -1);
          });
        }
      }

      makeFlagDropDownNotSelectable();
    }, [])

    return (
      // Mui-Form Control
      <FormControl error={!!error} fullWidth variant="outlined" margin="normal">

        {/* Tel-Input */}
        <div className="flex flex-col gap-1 relative w-full">
        <div className="text-[10px] font-[300] text-[#8B8E98] ">{label}</div>
        <Input
          country={"in"}
          value={value}
          onChange={handleOnChange}
          inputProps={inputProps}
          {...props}
          dropdownClass="react-app-flag-dropdown"
          buttonStyle={styles.buttonStyle(error, isFocused)}
          containerStyle={styles.containerStyle}
          dropdownStyle={styles.dropdownStyle}
        />
        </div>

        {/* Helper Text for errors/etc. */}
        {helperText && (
          <FormHelperText error={!!error}>
            {helperText || error?.message}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
);

// adds a readable name for the component in React DevTools and suppresses the ESLint warning.
CustomPhoneInput.displayName = "CustomPhoneInput";

export default React.memo(CustomPhoneInput);
